// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.santions-list .m-portlet .m-portlet__body {\n  padding: 2.2rem;\n}\n@media (max-width: 568px) {\n.santions-list .m-portlet .m-portlet__body {\n    padding: 1rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
